module.exports = __webpack_public_path__ + "img/startimg.711985d1.png";